<template>
  <footer :class="$route.name">
    <address>
      Copyright © {{ (new Date()).getFullYear() }} Seeall. All rights reserved.<br>
      <span class="link">
        <router-link :to="{ name: 'Terms' }">Terms of Service</router-link>
      </span>
      &middot;
      <span class="link">
        <router-link :to="{ name: 'PrivacyEurope' }">Privacy Policy (Europe)</router-link>
        <router-link :to="{ name: 'PrivacyGlobal' }">(Global)</router-link>
      </span>
    </address>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="scss" scoped>
footer {
  @media print {
    display: none;
  }

  &.SignIn,
  &.Report,
  &.TempReport,
  &.SharedReport {
    display: none;
  }

  address {
    padding: 30px 15px 40px;
    font-size: 12px;
    font-style: normal;
    text-align: center;
    color: #767676;
    line-height: 1.7;

    .link {
      margin: 0 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/AppFooter.vue